import { NewListPageComponent } from "../components/page/NewListPageComponent";
import { appendIdToFormFields, getEventMetadata, getSession } from "../helper";
import {
  CREATE_PERSON,
  DELETE_PERSON,
  LIST_PEOPLE,
  UPDATE_PERSON,
} from "./routes";
import { getPersonFormFields } from "./person_form";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import Card from "semantic-ui-react/dist/commonjs/views/Card/Card";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";

const PersonCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid key={props.data.id}>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
            cardData={props.data}
            props={{
              menuItems: [
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: {
                    documentNode: DELETE_PERSON,
                    key: "deletePerson",
                  },
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    setReloadKey((prev: number) => prev + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                    };
                  },
                  showMenuOption: (data: any) => {
                    return true;
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: {
                    documentNode: UPDATE_PERSON,
                    key: "updatePerson",
                  },
                  label: "Edit",
                  modalHeader: "Edit Person " + props.data.name,
                  showMenuOption: () => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getPersonFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                      id: props.data.id,
                      organizationIds: props.data.organizations.map(
                        (org: any) => org.id,
                      ),
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
              ],
            }}
          />
        </div>
      </Card.Content>
      <Card.Content className="organizations-section">
        {props.data.organizations && props.data.organizations.length > 0 && (
          <div className="organizations">
            <b>Organizations:</b>{" "}
            {props.data.organizations.map((org: any) => org.name).join(", ")}
          </div>
        )}
      </Card.Content>
    </Card>
  );
};

export const NewPeoplePage = () => {
  return (
    <NewListPageComponent
      props={{
        type: "list_page",
        query: {
          documentNode: LIST_PEOPLE,
          key: "listPeople",
        },
        queryVariables: {
          session: getSession(),
        },
        itemName: "Person",
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: {
              formFields: getPersonFormFields(),
              type: "single_form",
            },
            startingData: {
              name: "",
              organizationIds: [],
            },
          }),
          apiCall: {
            documentNode: CREATE_PERSON,
            key: "createPerson",
          },
        },
        card: PersonCard,
      }}
    />
  );
};
